import { useState, useEffect } from 'react';
/* datas */
import { HostBackend } from '../../../Routes/HostBackend.js';
import { GetHeaders } from '../../../Components/Admin/Functions/FetchHeaders.js';
import { FilterBkgColor } from '../Filters/FilterBkgColor.js';
import { GetTable } from '../Functions/GetTable.js';
import { GetUpperCase } from '../Functions/GetUpperCase.js';

export const FinderPublic = () => {
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const bkgNav = FilterBkgColor();
    const entity = GetTable();
    const table = entity.table;
    const label = entity.label;
    const [show0, setShow0] = useState('hide');
    const [show1, setShow1] = useState('hide');
    const [find, setFind] = useState('');
    const [result, setResult] = useState([]);
    useEffect(() => {
        if (find.length > 0) {
            const fetchDatas = async () => {
                try {
                    const dataResult = await fetch(`${backend}/public/find?table=${table}&find=${find}`, GetHeaders(guest));
                    const result = await dataResult.json();
                    setResult(result);
                } catch (e) {
                    console.log(e)
                }
            };
            fetchDatas();
        }
    }, [backend, table, find, guest]);
    if (result.length > 0) {
        return (
            <div className={`finder ${bkgNav}`}>
                <div className="label" onClick={(e) => { show0 === 'hide' ? setShow0('show') : setShow0('hide'); setShow1('hide'); }}>
                    <div>{GetUpperCase(label)}</div>
                    <i className="fa fa-search"></i>
                </div>
                <div className={`search ${show0} ${bkgNav}`}>
                    <input type="text" max="50" value={find} name="find" onChange={(e) => { setFind(e.target.value); setShow1('show'); }} />
                    <div className={`result ${show1}`}>
                        {result.map((el, i) => {
                            return (
                                <a className="link" key={`f-${i}`} href={el.route}>{el.name}</a>
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className={`finder ${bkgNav}`}>
                <div className="label" onClick={(e) => { show0 === 'hide' ? setShow0('show') : setShow0('hide'); setShow1('hide'); }}>
                    <div>{GetUpperCase(label)}</div>
                    <i className="fa fa-search"></i>
                </div>
                <div className={`search ${show0} ${bkgNav}`}>
                    <input type="text" max="50" value={find} name="find" onChange={(e) => { setFind(e.target.value); setShow1('show'); }} />
                </div>
            </div>
        )
    }
}